import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';// To use toastr
import { ajaxservice } from '../../../../services/ajaxservice';// Common API service for both get and post
import Swal from 'sweetalert2';   // its for alert

//autologout variables
var MINUTES_UNITL_AUTO_LOGOUT = 2; // set number of idle min allowed. in mins
const CHECK_INTERVAL = 6000 // set frequency in which idleness is checked. in ms
const STORE_KEY = 'lastAction';

@Injectable({
  providedIn: 'root'
})
export class TimeoutserviceService {

  intervalCheck: any;
  currentRouteUrl: string = '';
  role: any;
  roleId: any;

  constructor(private router: Router, private toastr: ToastrService,private ajax: ajaxservice) {}
  //auto logout methods
  public getLastAction() {
    //  get last mouse activity from local storage
    return parseInt(localStorage.getItem(STORE_KEY));
  }
  public setLastAction(lastAction: number) {
    // set last mouse activity in local storage
      localStorage.setItem(STORE_KEY, lastAction.toString());
      this.toastr.clear();
  }
  //get the role from the local storage and set the number of idle minutes allowed for each role.
  getRoleBasedIdleTime() {
    this.role = localStorage.getItem('pro_role_id');
    console.log(localStorage.getItem('pro_role_id'),"localStorage.getItem('pro_role_id')")
    console.log(this.role,'this.role')
    // if(this.role == 2 || this.role == 5 || this.role == 3 || this.role == 10) {
    //   MINUTES_UNITL_AUTO_LOGOUT = 30;
      MINUTES_UNITL_AUTO_LOGOUT = 10;
    // } else if(this.role == 4 || this.role == 7) {
    //   MINUTES_UNITL_AUTO_LOGOUT = 1;
    //   // MINUTES_UNITL_AUTO_LOGOUT = 3;
    // } else if(this.role == 9) {
    //   MINUTES_UNITL_AUTO_LOGOUT = 20;
    //   // MINUTES_UNITL_AUTO_LOGOUT = 2;
    // }
  }
  initListener() {
    //listen for mouse activity and set the time in the local storage
    document.body.addEventListener('click', () => this.setLastAction(Date.now()));
    document.body.addEventListener('mouseover', () => this.setLastAction(Date.now()));
    document.body.addEventListener('mouseout', () => this.setLastAction(Date.now()));
    document.body.addEventListener('keydown', () => this.setLastAction(Date.now()));
    document.body.addEventListener('keyup', () => this.setLastAction(Date.now()));
    document.body.addEventListener('keypress', () => this.setLastAction(Date.now()));
  }

  initInterval() {
    console.log("checking start")
    // check the mouse activity for the preset time interval
    this.intervalCheck = setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }
  getCurrentURL () {
    return window.location.href
  }
  
  check() {
    const now = Date.now();
    const timeleft = this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;
    const url = this.getCurrentURL()
    let lastSegment = url.substring(url.lastIndexOf('/') + 1);
    if (diff < (10 * 1000) && diff > 0 && lastSegment!="webform") {

      Swal.fire({        // fix the popup box work by harish
        title: 'Session Expired',
        text: "Do you want to continue?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#253f68 !important',
        cancelButtonColor: '#253f68 !important',
        confirmButtonText: 'Yes',
        cancelButtonText:"No",

      }).then((result) => {
        console.log(result,"result")
        Router
        if(result.isDismissed){
          console.log(result.isDismissed,"result.value")
          this.roleId = localStorage.getItem('pro_role_id');
          console.log('this.roleId',this.roleId)
          // if(this.roleId == 7){
            this.router.navigateByUrl('customer/webform');
          // }else{
          //   this.router.navigateByUrl('customer/new_enduser');
        // }
              localStorage.setItem('pro_role_id','');
              localStorage.setItem('reg_cust_code', '');
              localStorage.setItem('reg_cust_name', '');  
              // window.location.reload();
//               isConfirmed
// : 
// true
// isDenied
// : 
// false
// isDismissed
// : 
// false
// value
// : 
// true
        }else{
          console.log("enetereteereteretereterert")
          console.log(result.isDismissed,"result.value")
        }
         
  })
    }

    // if (isTimeout)
    if (isTimeout && lastSegment!="webform") {
      this.roleId = localStorage.getItem('pro_role_id');
        console.log('this.roleId',this.roleId)
        // if(this.roleId == 7){
          this.router.navigateByUrl('customer/webform');
        // }else{
          // this.router.navigateByUrl('customer/new_enduser');
        // }
      localStorage.removeItem(STORE_KEY);
      console.log("idle for 1 minute, rerouting....");
      clearInterval(this.intervalCheck);
      
          
      localStorage.setItem('pro_role_id','');
      localStorage.setItem('reg_cust_code', '');
      localStorage.setItem('reg_cust_name', '');  
          // window.location.reload();
        // }
     
    }
  }
}